// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/sass/colors/red.scss
// module id = 593
// module chunks = 376